import React from "react";

import { Grid } from "@material-ui/core";
import { useForm } from "react-hook-form";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";

import { Wrapper, Mensagem } from "./styles";
import { useApp } from "../../../../contexts";
import { paletas } from "../../../../styles/theme";
import { Botao, Modal, Loading } from "../../../../componentes";
import { appListagemDeVariavel } from "../../../../slices/app";
import { UpdateExperiencia } from "../../../../servicos";
import Questoes from "./Questoes";
import Algoritmos from "./Algoritmos";
import IntroducaoTreino from "./Introducao";
import { GerarResultado } from "./Funcoes/gerar-resultado";
import { GerarVariaveis } from "./Funcoes/gerar-variaveis";
import { MontarExpressao } from "./Funcoes/montar-expressao";

type FormData = {
  resposta: any;
};

type Props = {
  fecharModo: () => void;
};

export default function Treino({ fecharModo }: Props) {
  const { register, handleSubmit } = useForm<FormData>();
  const { usuario, setUsuarioCorrente } = useApp();
  let updateUsuario = usuario;

  const [iniciarTreinamento, setIniciarTreinamento] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [exibirResultado, setExibirResultado] = React.useState(false);
  const [bloquearAlgoritmo, setBloquearAlgoritmo] = React.useState(false);
  const [fraseResultado, setFraseResultado] = React.useState("");
  const [fraseRecompensa, setFraseRecompensa] = React.useState("");
  const [tipoAlgoritmo, setTipoAlgoritmo] = React.useState<number>(0);
  const [respostaCorreta, setRespostaCorreta] = React.useState(false);
  const [listagemDeVariaveis, setListagemDeVariaveis] = React.useState<
    number[]
  >([]);
  const [expressao, setExpressao] = React.useState<string[]>([]);
  const [resultadoFinal, setResultadoFinal] = React.useState<number>(0);

  const dispatch = useDispatch();
  const { nivelSelecionado } = useSelector(
    (state: RootStateOrAny) => state.appSystem
  );
  const nivel: number = nivelSelecionado;

  const iniciarTreino = () => {
    updateUsuario.system.in_combat = true;
    setUsuarioCorrente(updateUsuario);
    setIniciarTreinamento(true);
  };

  const finalizarTreino = () => {
    updateUsuario.system.in_combat = false;
    setUsuarioCorrente(updateUsuario);

    setIniciarTreinamento(false);
    setExibirResultado(false);
    setBloquearAlgoritmo(false);
  };

  // Montagem de variáveis para algoritmo
  React.useEffect(() => {
    setLoading(true);
    if (iniciarTreinamento) {
      const variaveis = GerarVariaveis({ nivel, tipoAlgoritmo });
      dispatch(appListagemDeVariavel(variaveis));
      setListagemDeVariaveis(variaveis);
    }
    setTimeout(() => {
      setLoading(false);
    }, 1500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iniciarTreinamento]);

  // Montagem estrutura de algoritmo
  React.useEffect(() => {
    if (listagemDeVariaveis) {
      const expressao = MontarExpressao({ nivel, tipoAlgoritmo });
      setExpressao(expressao);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listagemDeVariaveis]);

  // Montagem de respostas
  React.useEffect(() => {
    if (listagemDeVariaveis && expressao.length) {
      const result = GerarResultado({
        nivel,
        tipoAlgoritmo,
        expressao,
        listagemDeVariaveis,
      });
      result && setResultadoFinal(result);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expressao]);

  const atualizaUsuario = async (novoValor: number) => {
    try {
      if (navigator.onLine) {
        const dadosUpdate = {
          email: usuario.email,
          novoValor: novoValor,
        };
        UpdateExperiencia(dadosUpdate);
      } else {
        console.info("É necessário conexão com a internet!");
      }
    } finally {
    }
  };

  const calculaRecompensa = (dificuldade: number, tipo: number) => {
    const experiencia = usuario.player_statistics.experience;
    if (tipo === 0) {
      if (dificuldade === 0) {
        return (8 - experiencia / 100).toFixed(2);
      }
      if (dificuldade === 1) {
        return Number(10 - experiencia / 100).toFixed(2);
      }

      return Number(12 - experiencia / 100).toFixed(2);
    }
    if (tipo === 1) {
      if (dificuldade === 0) {
        return Number(14 - experiencia / 80).toFixed(2);
      }
      if (dificuldade === 1) {
        return Number(16 - experiencia / 80).toFixed(2);
      }

      return Number(18 - experiencia / 80).toFixed(2);
    }

    if (dificuldade === 0) {
      return Number(20 - experiencia / 60).toFixed(2);
    }
    if (dificuldade === 1) {
      return Number(22 - experiencia / 60).toFixed(2);
    }

    return Number(24 - experiencia / 60).toFixed(2);
  };

  const onSubmit = handleSubmit((data) => {
    const respostaEnviada: number = data.resposta;
    setBloquearAlgoritmo(true);
    setExibirResultado(true);

    if (Number(respostaEnviada) === Number(resultadoFinal)) {
      setRespostaCorreta(true);
      if (nivel === 0) {
        const resultadoRecompensa = calculaRecompensa(tipoAlgoritmo, nivel);
        const novoValor: number =
          Number(updateUsuario.player_statistics.experience) +
          Number(resultadoRecompensa);
        updateUsuario.player_statistics.experience = novoValor;
        setUsuarioCorrente(updateUsuario);
        localStorage.setItem(
          "@batalha-dev/usuario",
          JSON.stringify(updateUsuario)
        );
        setFraseResultado(`Parabéns! O resultado é: ${resultadoFinal}!`);
        setFraseRecompensa(`Recompensa: ${resultadoRecompensa} EXP`);
        atualizaUsuario(novoValor);
      }
      if (nivel === 1) {
        const resultadoRecompensa = calculaRecompensa(nivel, tipoAlgoritmo);
        const novoValor: number =
          Number(updateUsuario.player_statistics.experience) +
          Number(resultadoRecompensa);
        updateUsuario.player_statistics.experience = novoValor;
        setUsuarioCorrente(updateUsuario);
        localStorage.setItem(
          "@batalha-dev/usuario",
          JSON.stringify(updateUsuario)
        );
        setFraseResultado(`Parabéns! O resultado é: ${resultadoFinal}!`);
        setFraseRecompensa(`Recompensa: ${resultadoRecompensa} EXP`);
        atualizaUsuario(novoValor);
      }
      if (nivel === 2) {
        const resultadoRecompensa = calculaRecompensa(nivel, tipoAlgoritmo);
        const novoValor: number =
          Number(updateUsuario.player_statistics.experience) +
          Number(resultadoRecompensa);
        updateUsuario.player_statistics.experience = novoValor;
        setUsuarioCorrente(updateUsuario);
        localStorage.setItem(
          "@batalha-dev/usuario",
          JSON.stringify(updateUsuario)
        );
        setFraseResultado(`Parabéns! O resultado é: ${resultadoFinal}!`);
        setFraseRecompensa(`Recompensa: ${resultadoRecompensa} EXP`);
        atualizaUsuario(novoValor);
      }
    } else {
      setFraseResultado(`Desculpe! O resultado é: ${resultadoFinal}`);
      setRespostaCorreta(false);
    }
  });

  return (
    <Wrapper>
      {!iniciarTreinamento ? (
        <>
          <IntroducaoTreino
            onIniciar={iniciarTreino}
            setTipoAlgoritmo={setTipoAlgoritmo}
            tipoAlgoritmo={tipoAlgoritmo}
          />
          <Grid container justify="flex-end">
            <Grid item xs={5} sm={2}>
              <Botao
                type="button"
                value="VOLTAR"
                background={paletas.RedTheme}
                border={paletas.RedTheme}
                color={paletas.White}
                size="16px"
                disabled={false}
                onClick={fecharModo}
              />
            </Grid>
          </Grid>
        </>
      ) : (
        <Grid
          container
          item
          alignContent="center"
          alignItems="center"
          justify="center"
          className="container"
        >
          <Loading loading={loading} cor={paletas.DarkOrange}>
            <Grid
              container
              item
              spacing={3}
              justify="space-between"
              className={`${exibirResultado ? "escurecer" : ""}`}
            >
              <Grid item xs={12} md={6}>
                <Algoritmos expressao={expressao} tipo={tipoAlgoritmo} />
              </Grid>

              <Grid item xs={12} md={6}>
                <form onSubmit={onSubmit}>
                  <Questoes
                    resultado={resultadoFinal}
                    bloquear={bloquearAlgoritmo}
                    register={register}
                    tipoAlgoritmo={tipoAlgoritmo}
                  />
                </form>

                <Grid container justify="flex-end" className="mensagem">
                  <Grid item xs={6} sm={4}>
                    <Botao
                      type="button"
                      value="ENCERRAR"
                      background={paletas.RedTheme}
                      border={paletas.Grafite}
                      color={paletas.White}
                      size="16px"
                      disabled={false}
                      onClick={finalizarTreino}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Loading>

          {exibirResultado && (
            <Mensagem>
              <Modal
                frase={fraseResultado}
                recompensa={fraseRecompensa}
                respostaCorreta={respostaCorreta}
                valorBotao="INÍCIO"
                onClick={() => finalizarTreino()}
                fechar={() => setExibirResultado(false)}
              />
            </Mensagem>
          )}
        </Grid>
      )}
    </Wrapper>
  );
}
